module.exports = __webpack_public_path__ + "static/img/Quicksand-Bold.6a04350.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Quicksand-Bold.svg
// module id = 41T3
// module chunks = 1